import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "vireo_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === product.slug);
      if (found) {
        return prev.map((i) => (i.slug === product.slug ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [
        ...prev,
        { slug: product.slug, name: product.name, price: product.price, image: product.image, quantity: qty },
      ];
    });
    setOpen(true);
  };

  const removeItem = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));

  const updateQty = (slug, quantity) => {
    if (quantity <= 0) return removeItem(slug);
    setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, quantity } : i)));
  };

  const clear = () => setItems([]);

  const { count, subtotal } = useMemo(() => {
    const count = items.reduce((a, i) => a + i.quantity, 0);
    const subtotal = items.reduce((a, i) => a + i.price * i.quantity, 0);
    return { count, subtotal };
  }, [items]);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQty, clear, count, subtotal, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
